import $ from "jquery";
window.$ = window.jQuery = $;

import "../../assets/styles/index.scss";
import "bootstrap/dist/js/bootstrap";

import { handleBackToTopButton } from './plugins/back-to-top';
import { handleMenuBar } from './plugins/menu-bar';
import { handlePortfolioCharts } from './plugins/portfolio-charts';
import { handlePerformanceSummaryBlock } from './plugins/performance-summary';
import { handleVideoLeftTextRightModalBlock } from './plugins/video-left-text-right';
import { handleRecentTrendsGraph1 } from './plugins/recent-trends-chart-1';
import { handleRecentTrendsGraph2 } from './plugins/recent-trends-chart-2';
import { handleRecentTrendsGraph3 } from './plugins/recent-trends-chart-3';
import { handleMapBox } from './plugins/map-box';
import { handleMembershipForm } from './plugins/membership';
import { handleContactForm } from './plugins/contact';
import { handleAttestation } from './plugins/attestation';
import { handleVideoCardsModalBlock } from './plugins/video-cards';

var app = function() {

    return {               

        init: function() {

            handleMenuBar();
            handleVideoCardsModalBlock();
            handleVideoLeftTextRightModalBlock();
            handlePortfolioCharts();
            handlePerformanceSummaryBlock();
            handleRecentTrendsGraph1();
            handleRecentTrendsGraph2();
            handleRecentTrendsGraph3();
            handleBackToTopButton();
            handleMapBox();
            handleMembershipForm();
            handleContactForm();         
            handleAttestation();
          

        }
    }

}();

$( window ).on("load", function() {

    app.init();

});
